module.exports = __webpack_public_path__ + "img/icon_usdt.8fa441c5.svg";